module.exports = {
    Lang: {
        de: 'немецкий',
        en: 'английский',
        es: 'испанский',
        fr: 'французский',
        pt: 'Португальский',
        it: 'Итальянский',
        ru: 'русский'
    },
    Action: {
        add: 'Добавить',
        edit: 'Обработать',
        remove: 'Удалить заказ',
        close: 'Закрыть',
        select: 'Выберите',
        save: 'Сохранить',
        saving: 'Спасен',
        send: 'Отправить',
        confirmSelection: 'подтвердить выбор',
        change: 'Изменить',
        changeSelection: 'Выбор изменений',
        next: 'Далее',
        prev: 'Назад',
        finish: 'Готово',
        'search': 'Поиск'
    },
    Common: {
        start: 'Начать',
        date: 'Дата',
        creationdate: 'Дата создания',
        lastmodified: 'Последнее изменение',
        status: 'Состояние',
        color: 'Цвет',
        settings: 'Настройки',
        masterdata: 'Основные данные',
        masterdataSaved: 'Основные данные сохранены',
        amount: 'Сумма',
        description: 'Описание',
        item: 'Товар',
        itemNum: '№ товара',
        itemName: 'Название товара',
        itemPrice: 'Цена на изделие',
        quantity: 'Количество',
        singlePrice: 'Розничная цена',
        discount: 'Скидка',
        rebate: 'Скидка',
        vat: 'НДС',
        total: 'Всего',
        orderPrice: 'Цена заказа',
        annotation: 'Примечание',
        accountDetails: 'Данные клиента',
        customerNum: 'Номер клиента',
        salutation: 'Обращение',
        firstname: 'Имя',
        lastname: 'Фамилия',
        company: 'Фирма',
        email: 'Эл. почта',
        contact: 'Адрес',
        address: 'Адрес',
        postalcode: 'Индекс',
        city: 'Город',
        country: 'Страна',
        taxDetails: 'Налоговые данные',
        vatId: '№ пл-ка НДС',
        noEntries: 'Нет записей',
        languageSettings: 'Настройки языка',
        showXtoYentries: 'Показать с {x} по {y} Результаты',
        showXtoYofZentries: 'Покажи {x} пока {y} от {z} Результаты',
        errorSavingMasterdata: 'Основные данные не могут быть сохранены.',
        errorIncomplete: 'Форма неполнаяo',
        errorFieldMissing: '{field} должен быть заполнен',
        errorUploadInvalidResp: 'Недействительный ответ сервера. Пожалуйста, попробуйте еще раз или свяжитесь с нашей службой поддержки.',
        noSelection: 'Нет выбора'
    },
    Units: {
        C62: 'pcs.',
        GRM: 'g'
    },
    Dashboard: {
        title: 'Приборная панель'
    },
    Addresses: {
        title: 'Адреса',
        add: 'новый адрес',
        addressMain: 'Основной адрес',
        addressBilling: 'Адрес для выставления счёта',
        addressShipping: 'Адрес доставки',
        confirmRemove: 'Вы действительно хотите удалить контакт?',
        errorLoad: 'Адреса не могли быть загружены.',
        errorRemove: 'Адрес не может быть удален.'
    },
    EditAddress: {
        title: 'новый адрес',
        errorTypeTitle: 'Пожалуйста, определите тип адреса.',
        errorTypeText: 'Адрес должен быть адресом доставки и/или адресом счета-фактуры.',
        errorCreate: 'Адрес не удалось создать.',
        errorUpdate: 'Адрес не может быть обновлен.',
        shipping: 'доставка',
        useForShippingNo: 'Не используйте в качестве адреса доставки',
        useForShippingYes: 'Использовать в качестве адреса доставки',
        useForShippingDefault: 'Использовать в качестве стандартного адреса доставки',
        billing: 'Счета',
        useForBillingNo: 'Не используйте в качестве адреса для выставления счетов',
        useForBillingYes: 'Использовать в качестве адреса для выставления счетов',
        useForBillingDefault: 'Использовать в качестве адреса для выставления счетов по умолчанию'
    },
    Projects: {
        title: 'Отчеты',
        loading: 'Отчеты загружены',
        currentProjects: 'текущие отчёты',
        showAll: 'Показывать все отчеты',
        noProjects: 'Нет сообщений',
        add: 'Новый отчет',
        projectNumber: 'Доклад Нет.',
        projectName: 'ID пациента',
        projectType: 'Тип отчета',
        statusAll: 'Все доклады',
        statusOpen: 'Открытые доклады',
        statusOrdered: 'Заказанные отчёты',
        errorNoName: 'Введите название отчета.',
        errorCreate: 'Отчет не мог быть создан.',
        errorCouldNotLoad: 'Отчеты не могут быть загружены.'
    },
    ProjectDetails: {
        title: 'Информация о заказе',
        loading: 'Отчет загружен',
        alertOrdered: 'Отчёт приказал',
        openOrder: 'Открытый заказ',
        alertReference: 'Этот проект связан с другим проектом:',
        openProject: 'Открытый доклад',
        toothSelection: 'отбор зубов',
        noConstruction: 'Keine Konstruktion festgelegt!',
        editConstruction: 'Kontruktion bearbeiten',
        materialSelection: 'Materialauswahl',
        estimatedDelivery: 'Vorauss. Lieferdatum',
        missingMaterial: 'Materialauswahl fehlt',
        missingAttachments: 'Приложения отсутствуют:',
        addStl: 'STL hinzufügen',
        openCart: 'В корзину',
        emptyCart: 'Корзина пуста',
        shippingType: 'Метод доставки',
        construction: 'Konstruktion',
        stlUpload: 'STL Upload',
        attachments: 'Приложения',
        addons: 'Дополнительная продукция',
        cart: 'Корзина',
        addItem: 'Добавить товар',
        orderProject: 'Обязательный заказ',
        statusNotOrdered: 'Не заказано',
        statusOrdered: 'Заказы',
        errorNoProjectnum: 'Номер действительного переданного отчета не передан',
        costs: 'Стоимость проекта',
        removed: 'Проект снят',
        removing: 'Проект удален',
        saved: 'Проект сохранен',
        saving: 'Проект сохранен',
        orderSuccessful: 'Заказ успешен'
    },
    Orders: {
        title: 'Заказы',
        loading: 'Заказы загружены',
        currentOrders: 'Текущие заказы',
        openOrder: 'Открытый заказ',
        showAll: 'Показать все заказы',
        noOrders: 'Нет заказов',
        orderNum: '№ заказа',
        projectRef: 'Данные проекта',
        statusAll: 'Все заказы',
        errorCouldNotLoad: 'Заказы не могут быть загружены',
        statusNotOrdered: 'Не заказано',
        statusReceived: 'Получено',
        statusCancelled: 'Отменено',
        statusReceivedDescr: 'Заказ проверен',
        statusInProgress: 'В процессе',
        statusInProgressDescr: 'Ваш заказ обрабатывается',
        statusInProduction: 'В производстве',
        statusInProductionDescr: 'Начато производство',
        statusDelivered: 'Отправлено',
        statusDeliveredDescr: 'Ваш заказ был отправлен'
    },
    Reports: {
        statusAll: 'Все доклады',
        statusReceived: 'Данные сформированы',
        statusReceivedDescr: 'Заказ проходит проверку',
        statusInProgress: 'В обработке',
        statusInProgressDescr: 'Идет обработка данных.',
        statusInProduction: 'Макет отчета создан',
        statusInProductionDescr: 'Ваш шаблон отчета создан',
        statusOnHold: 'Содержание',
        statusCancelled: 'Отменено',
        statusCancelledDescr: 'Ваш заказ был аннулирован.',
        statusClosed: 'Отчет создан',
        statusCompleted: 'Отчет создан',
        statusCompletedDescr: 'Вы создали отчет',
        statusInvoicedCancelled: 'Teilberechnet / Storniert',
        statusPartlyDelivered: 'Teilgeliefert',
        statusPartlyDeliveredCancelled: 'Teilgeliefert / Storniert',
        statusPartlyDeliveredClosed: 'Teilgeliefert / Geschlossen',
        statusDelivered: 'Отчет создан',
        statusDeliveredDescr: 'Ваш отчет полон',
        statusReadyForPickup: 'Готовы к сбору',
    },
    OrderDetails: {
        title: 'Информация о заказе',
        deliveryNote: 'транспортная накладная',
        loading: 'Заказ загружен',
        trackingNum: 'Отслеживание Нет.',
        manufacturingStatus: 'Статус продукции',
        trackingAndBilling: 'Отслеживание и выставление счетов',
        creatingOrder: 'Порядок создан',
        orderProject: 'Обязательный заказ',
        placeOrder: 'Закрыть заказ',
        acceptTerms: 'Я прочитал(а) и принял(а) <a href="{termsUrl}" target="_blank">Общие условия использования</a>.',
        errorNoOrderNum: 'Номер действующего заказа не передан',
        errorCouldNotLoad: 'Заказ не может быть загружен',
        priceNobleMetal1: 'Der Endgültige Produktpreis ist bei Edelmetallen vom endgültigen Gewicht abhängig.',
        priceNobleMetal2: 'Bitte prüfen Sie hierzu Ihren Lieferschein, sobald der Auftrag abgeschlossen ist.',
        files: 'Файлы'
    },
    Messages: {
        title: 'Новости',
        noMessages: 'Keine Nachrichten',
        errorCouldNotLoad: 'Nachrichten konnte nicht geladen werden',
        writeSomething: 'Schreiben Sie was...',
        errorSendingMessage: 'Nachricht konnte nicht gesendet werden.'
    },
    Configurator: {
        selectIndication: 'Indikation wählen',
        changeMaterial: 'Material ändern',
        selectTooth: 'Bitte wählen Sie einen Zahn',
        showToothNumbers: 'Zahnnummern anzeigen',
        toothSelection: 'Zahnauswahl',
        setProductProps: 'Produkteigenschaften festlegen',
        selectProduct: 'Produkt wählen',
        fileXofY: 'Datei {x} von {y}',
        calcPrice: 'Preise werden berechnet',
        uploadStl: 'STL hochladen',
        stlCount: 'Einheitenanzahl der obigen STL',
        stlCountTooltip: 'Bitte Einheitenanzahl der STL-Datei angeben, z.B. 3 Einheiten bei dreigliedriger Brücke',
        oneUnit: 'Eine Einheit',
        nUnits: '{n} Einheiten',
        removeJawSelection: 'Wollen sie die bestehende Auswahl in diesem Kiefer entfernen?',
        invalidTeethInRange: 'The {0} teeth is invalid for range {1}-{2}.',
        invalidRange: 'The {0}-{1} tooth range is invalid. The start/end teeth have to be on the same jaw.',
        invalidTeethNumber: 'The {0} is invalid teeth number.',
        transferSettings: 'Do you want to transfer those settings to multiple teeth?',
        clickOnConnectTooth: 'Click on the tooth you want to connect to'
    },
    Invoices: {
        title: 'Rechnungen',
        loading: 'Rechnungen werden geladen',
        invoiceNum: 'Rechnung Nr.',
        monthlyStatement: 'Monatsaufstellung',
        statusReceived: 'Eingegangen',
        statusOpen: 'Offen',
        statusHold: 'Gehalten',
        statusCancelled: 'Storniert',
        statusClosed: 'Geschlossen',
        statusPartlyPaid: 'Teilbezahlt',
        statusPartlyPaidCancelled: 'Teilbezahlt / Storniert',
        statusPartlyPaidClosed: 'Teilbezahlt / Geschlossen',
        statusPaid: 'Bezahlt'
    },
    File: {
        name: 'Имя файла',
        hash: 'Хэш-файл',
        size: 'Размер файла',
        messageUpload: 'Нажмите для загрузки или перетащите файл из поля.',
        allFilesSameMaterial: 'Alle Dateien haben das gleiche Material',
        sendingData: 'Передаются данные',
        processingData: 'Данные обрабатываются',
        errorUpload: 'Произошла ошибка. К сожалению, файл не удалось загрузить.',
        errorCouldNotList: 'Файлы не могли быть загружены.',
        errorCouldNotLoad: 'Файл нельзя было загрузить.',
        errorCouldNotDelete: 'Файл нельзя было удалить.'
    },
    Login: {
        username: 'Эл. почта или номер клиента',
        password: 'Пароль',
        passwordOld: 'Старый пароль',
        passwordNew: 'Новый пароль',
        passwordConfirm: 'Подтвердить новый пароль',
        passwordSaved: 'Пароль сохранен',
        login: 'Имя пользователя',
        logout: 'Выйти',
        enterPwd: 'Введите пароль',
        invalidUserOrPwd: 'Неправильное имя пользователя/пароль',
        errorCouldNotUpdate: 'Пароль не удалось сохранить.',
        errorPasswordNoMatch: 'Пароли не совпадают.',
        errorOldPassword: 'Старый пароль неверен.',
        errorNoSession: 'Сессия пользователя не найдена. Пожалуйста, войдите в систему.'
    },
    Infothek: {
        title: 'Infothek'
    }
};
